import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

const nav = [
  { to: "/", label: "首页" },
  { to: "/category/huati", label: "热门话题" },
  { to: "/category/shijian", label: "热点事件" },
  { to: "/category/renwu", label: "人物动态" },
  { to: "/category/jigou", label: "机构观察" },
];

export default function Header() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const isActive = (to: string) =>
    to === "/" ? pathname === "/" : pathname.startsWith(to);

  return (
    <header
      className={`sticky top-0 z-40 w-full border-b transition-colors ${
        scrolled || open
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
              导航爆料
            </span>
            <span className="mt-1 text-[11px] text-foreground-500">分类浏览 · 高效吃瓜</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {nav.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                isActive(item.to)
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <Link
            to="/about"
            className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap px-3 py-2 text-sm text-foreground-600 transition-colors hover:text-foreground-950"
          >
            <i className="ri-information-line"></i>
            关于我们
          </Link>
          <Link
            to="/faq"
            className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-4 py-2 text-sm font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
          >
            <i className="ri-question-line"></i>
            常见问题
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg text-foreground-800 hover:bg-background-100 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {nav.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-lg px-3 py-2.5 text-sm font-medium ${
                  isActive(item.to)
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="mt-2 flex gap-2 border-t border-background-200 pt-3">
              <Link
                to="/about"
                className="inline-flex flex-1 cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-lg bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800"
              >
                <i className="ri-information-line"></i>关于我们
              </Link>
              <Link
                to="/faq"
                className="inline-flex flex-1 cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-lg bg-secondary-100 px-3 py-2.5 text-sm font-medium text-secondary-900"
              >
                <i className="ri-question-line"></i>常见问题
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* 隐藏的分类入口（SEO 语义用） */}
      <div className="hidden">
        {categories.map((c) => (
          <Link key={c.slug} to={`/category/${c.slug}`}>{c.name}</Link>
        ))}
      </div>
    </header>
  );
}